// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__nbU9i","dark":"BaseLayout_dark__RTFJa","light":"BaseLayout_light__O3ynT"};